import React from 'react';

export const BackLeftIcon = ({ props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <title>back</title>
    <path
      d="M9 11.999L14.241 6l.759.657-4.666 5.342L15 17.343l-.759.657z"
      fillRule="evenodd"
    />
  </svg>
);
